import React from "react";
import VentureCapitalBlock from "../components/VentureCapital/VentureCapitalBlock";
export default function VentureCapital() {
    return (
        <section>
            <VentureCapitalBlock/>
        </section>



    );
}